import { ReloadIcon, RocketIcon } from "@radix-ui/react-icons";
import moment from "moment";
import { useSelector } from "react-redux";
import UserCard from "src/components/UserCard";
import { Alert, AlertDescription, AlertTitle } from "src/components/ui/alert";
import { Button } from "src/components/ui/button";
import useSWR from "swr";

const fetcher = (token) => async (url) => {
  const res = await fetch(url, { headers: { Authorization: token } });

  // If the status code is not in the range 200-299,
  // we still try to parse and throw it.
  if (!res.ok) {
    const error: any = new Error("An error occurred while fetching the data.");
    // Attach extra info to the error object.
    error.info = await res.json();
    error.status = res.status;
    throw error;
  }

  return res.json();
};

export default function Nearby() {
  const user = useSelector((state: any) => state.user);

  const { data, error, isLoading, mutate, isValidating } = useSWR<
    {
      userId: string;
      updatedAt: number;
    }[]
  >(
    user.behavior.searchNearby
      ? `${process.env.REACT_APP_API_URL}/users/nearby`
      : null,
    fetcher(user.token),
    {
      refreshInterval: 10000,
    }
  );

  const errorMessage =
    error?.info?.error === "No location found"
      ? "Ještě neznáme tvoji polohu, zkus to prosím později"
      : "Někde se stala chyba, zkus to prosím později";

  return (
    <>
      <h2
        style={{
          fontWeight: "500",
          textAlign: "center",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "0.25rem",
        }}
      >
        <span>Uživatelé poblíž</span>
        <span
          style={{ color: "hsl(var(--muted-foreground))", fontWeight: "400" }}
        >
          (1 km)
        </span>
        <Button
          variant="outline"
          size="icon"
          disabled={isLoading || isValidating}
          onClick={() => mutate()}
        >
          <ReloadIcon />
        </Button>
      </h2>
      <div
        className="p-4"
        style={{ display: "flex", flexDirection: "column", gap: "1rem" }}
      >
        {!user.behavior.searchNearby && (
          <Alert>
            <RocketIcon className="h-4 w-4" />
            <AlertTitle>Sdílení polohy je vypnuté</AlertTitle>
            <AlertDescription>
              Chceš-li vidět uživatele poblíž, zapni sdílení polohy v nastavení
              uživatele kliknutím na ikonu vpravo nahoře.
            </AlertDescription>
          </Alert>
        )}
        {user.behavior.searchNearby && (
          <>
            {isLoading && !data && (
              <div style={{ textAlign: "center" }}>Načítání</div>
            )}
            {error && !data && (
              <div style={{ textAlign: "center" }}>{errorMessage}</div>
            )}
            {data && data.length === 0 && (
              <div style={{ textAlign: "center" }}>Žádní uživatelé</div>
            )}
            {data &&
              data.map((user) => (
                <UserCard
                  key={user.userId}
                  userId={user.userId}
                  Content={({ data }) => (
                    <div
                      style={{
                        color: "hsl(var(--muted-foreground))",
                        fontSize: "0.75rem",
                      }}
                    >
                      {moment
                        .duration(user.updatedAt - new Date().getTime())
                        .locale("cs")
                        .humanize(true)}
                    </div>
                  )}
                />
              ))}
          </>
        )}
      </div>
    </>
  );
}
